import { getTransferTypes } from '@/services/files.service';
import { getBanks } from '@/services/banks.service';
import {
  getProviderFile,
  getProviderFileAttachments,
  getProviderFilePayments,
  getProviderFileAffiliateFiles,
  getProviderCBUs,
  getProviderFilePaymentAttachments,
} from '@/services/providerFiles.service';
import { history } from '@umijs/max';
import { normalizeResults } from '@/utils/utils';


const Model = {
  namespace: 'providerFileDetail',

  state: {
    file: null,
    transferTypes: [],
    banks: [],
    attachments: [],
    payments: [],
    affiliateFiles: [],
    providerEnabledCbu: null,
    paymentAttachments: [],
    loading: true,
    paymentAttachmentsLoading: false,
    paymentSetupLoading: false,
  },

  effects: {
    *fetchAll({ payload }, { call, put, all }) {
      yield put({ type: 'show', payload: { loading: true } });
      try {
        const [fileRes, transferTypesRes, banksRes] = yield all([
          call(getProviderFile, payload.id),
          call(getTransferTypes),
          call(getBanks),
        ]);
        const file = fileRes.data;
        const transferTypes = (Array.isArray(transferTypesRes.data) ? transferTypesRes.data : []).filter(
          (item) => item?.enabled !== false,
        );
        const banks = Array.isArray(banksRes.data) ? banksRes.data : [];

        let attachments = [];
        let payments = [];
        try {
          const [attachmentsRes, paymentsRes] = yield all([
            call(getProviderFileAttachments, payload.id),
            call(getProviderFilePayments, payload.id),
          ]);
          attachments = normalizeResults(attachmentsRes.data);
          payments = normalizeResults(paymentsRes.data);
        } catch {}

        yield put({
          type: 'show',
          payload: {
            file,
            transferTypes,
            banks,
            attachments,
            payments,
            affiliateFiles: normalizeResults(file.affiliate_files),
            loading: false,
          },
        });

        if (file?.provider?.id || file?.provider) {
          yield put({
            type: 'fetchProviderCbu',
            payload: { providerId: file.provider?.id || file.provider },
          });
        }
      } catch {
        history.push('/404');
        yield put({ type: 'show', payload: { loading: false } });
      }
    },

    *fetchProviderCbu({ payload }, { call, put }) {
      yield put({ type: 'show', payload: { paymentSetupLoading: true, providerEnabledCbu: null } });
      try {
        const response = yield call(getProviderCBUs, payload.providerId);
        const cbus = normalizeResults(response.data);
        yield put({
          type: 'show',
          payload: {
            providerEnabledCbu: cbus.find((cbu) => cbu.status === 'ENABLED') || null,
            paymentSetupLoading: false,
          },
        });
      } catch {
        yield put({ type: 'show', payload: { providerEnabledCbu: null, paymentSetupLoading: false } });
      }
    },

    *refreshFile({ payload }, { call, put }) {
      try {
        const fileRes = yield call(getProviderFile, payload.id);
        yield put({
          type: 'show',
          payload: {
            file: fileRes.data,
            affiliateFiles: normalizeResults(fileRes.data.affiliate_files),
          },
        });
      } catch {}
    },

    *refreshAttachments({ payload }, { call, put, all }) {
      try {
        const [fileRes, attachmentsRes] = yield all([
          call(getProviderFile, payload.id),
          call(getProviderFileAttachments, payload.id),
        ]);
        yield put({
          type: 'show',
          payload: { file: fileRes.data, attachments: normalizeResults(attachmentsRes.data) },
        });
      } catch {}
    },

    *refreshPayments({ payload }, { call, put, all }) {
      try {
        const [fileRes, paymentsRes] = yield all([
          call(getProviderFile, payload.id),
          call(getProviderFilePayments, payload.id),
        ]);
        yield put({
          type: 'show',
          payload: {
            file: fileRes.data,
            payments: normalizeResults(paymentsRes.data),
          },
        });
      } catch {}
    },

    *refreshAffiliateLinks({ payload }, { call, put, all }) {
      try {
        const [fileRes, affiliateFilesRes] = yield all([
          call(getProviderFile, payload.id),
          call(getProviderFileAffiliateFiles, payload.id),
        ]);
        yield put({
          type: 'show',
          payload: {
            file: fileRes.data,
            affiliateFiles: normalizeResults(affiliateFilesRes.data),
          },
        });
      } catch {}
    },

    *fetchPaymentAttachments({ payload }, { call, put }) {
      yield put({ type: 'show', payload: { paymentAttachmentsLoading: true } });
      try {
        const response = yield call(getProviderFilePaymentAttachments, payload.fileId, payload.paymentId);
        yield put({
          type: 'show',
          payload: { paymentAttachments: normalizeResults(response.data), paymentAttachmentsLoading: false },
        });
      } catch {
        yield put({ type: 'show', payload: { paymentAttachments: [], paymentAttachmentsLoading: false } });
      }
    },
  },

  reducers: {
    show(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};

export default Model;
